// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".finances .tabs__navigation-item+.tabs__navigation-item{border-left:none}.finances .dashboard_contents{padding:0}.finances__filters{padding:20px 0;background:#fff;align-items:center;margin-bottom:18px}.finances__filters-item{width:auto}.finances .custom-select-wrapper{margin:0 auto}", ""]);
// Exports
module.exports = exports;
